import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const SuccessPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Porosia u bë me sukses | Premium Perfume KS";
  }, []);
  return (
    <Container>
      <h1>{t("successTitle")}</h1>
      <h2>{t("successSubtitle")}</h2>
      <p>{t("successMessage")}</p>
      <Link to={"/produktet"}>
        <button>{t("successBtn")}</button>
      </Link>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 5%;
  text-align: center;
  h1 {
    font-family: "Comfortaa", sans-serif;
    font-size: 5em;
    font-weight: 200;
  }
  h2 {
    margin: 1em;
    font-weight: 500;
  }
  p {
    color: #cacaca;
  }
  button {
    margin: auto;
    font-family: "Poppins", sans-serif;
    font-size: 18px;
    background: white;
    color: #777777;
    border: none;
    padding: 15px 24px;
    transition: 0.4s;
    margin: 1em;
    border: 1px solid #c7c7c7;
    cursor: pointer;
    &:hover {
      background: var(--primaryColor);
      color: white;
    }
  }
  @media (max-width: 450px) {
    h1 {
      font-size: 16vw;
    }
  }
`;

export default SuccessPage;
